import * as yup from 'yup'

import { trimmedInputValues, capitalizeWordsInValue } from '../utils';


const TicketAddValidation = yup.object().shape({

    // ticketName: yup.string().transform((value) => trimmedInputValues(value)).required('This Field is required').transform((value) => capitalizeWordsInValue(value)),
    // ticketDescription: yup.string().transform((value) => trimmedInputValues(value)).required('This Field is required'),

    ticketName: yup.string()
    .transform((value) => trimmedInputValues(value))
    .transform((value) => capitalizeWordsInValue(value))
    .test('len', 'Must Not increase 256 characters', value => value.length < 256)
    .required('Ticket name is required'),

    ticketDescription: yup.string()
    .transform((value) => trimmedInputValues(value))
    .transform((value) => capitalizeWordsInValue(value))
    .test('len', 'Ticket description must not increase 1000 characters', value => value.length < 1001)
    .required('Ticket description is required'),

    ticketCategoryId: yup.number().required('Ticket category is required'),
    ticketSubcategoryId: yup.number().required('Ticket subcategory is required'),
    ticketPriority: yup.string().required('Ticket priority is required').trim(),
    ticketAssignee: yup.number().required('Ticket assignee is required'),
    ticketDueDate:  yup.string().required('Ticket due date is required'),
    pmBranchId: yup.number().required('Pm Branch is required')
})

const ticketAddInitialState = {
    ticketName: '',
    ticketDescription: '',
    // ticketStatus: '',
    ticketCategoryId: null,
    ticketSubcategoryId: null,
    ticketPriority: '',
    ticketAssignee: null,
    ticketFollower: [],
    ticketDueDate: '',
    ticketCreatedBy: null,
    ticketDocument: '',
    ticketDefaultAssignees: [],
    ticketEmailAlerts : false,
    ticketParamValues : null,
    companyId : null,
    branchId : null,
    pmBranchId: null
}


const TicketEditValidation = yup.object().shape({
    // ticketName: yup.string().required('This Field is required').trim(),
    ticketStatus: yup.string().required('This Field is required').trim(),
    ticketDueDate:  yup.string().required('This Field is required'),
})

const ticketEditInitialState = {
    ticketName: '',
    ticketStatus: '',
    ticketDueDate: '',
    ticketDescription: '',
    ticketCreatedAt: '',
    ticketCreatedUserName: ''
}

const ticketSearchInitialState = {
    ticketDateType: '',
    ticketFromDate: '',
    ticketToDate: '',
    ticketStatus: '',
    ticketPerPage: '',
    ticketCategory: '',
    ticketAssigne: '',
    ticketTitle: '',
    ticketFollows: '',
}

export { TicketAddValidation, ticketAddInitialState, TicketEditValidation, ticketEditInitialState, ticketSearchInitialState };